import { getCategories } from '@/api/categories'
import {
  SET_LIST_CATEGORY
} from '@/store/mutation-types'

const fetchCategories = ({state, commit}, params = {}) => {
  if (!state.categoriesFetched || params.force) {
    commit('SET_CATEGORIES_FETCHED', true)
    getCategories({limit: 1000, ...params}).then(function (response) {
      switch (response.status) {
        case 1:
          commit(SET_LIST_CATEGORY, response.data)
          break
        default:
          break
      }
    })
  }
}

export default {
  fetchCategories
}



// WEBPACK FOOTER //
// ./src/components/category/store/actions.js